import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown, FiChevronUp, FiInfo } from "react-icons/fi";
import { useStatsigClient, useDynamicConfig } from "@statsig/react-bindings";
import "./Accordion.scss";
import { AI_ASSISTANT_CONSTANTS } from "../../constants/aiAssistantConstants";

const Accordion = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null);

    const { checkGate, client } = useStatsigClient();
    const config = useDynamicConfig(AI_ASSISTANT_CONSTANTS.DYNAMIC_CONFIGS.AI_ASSISTANT_CONFIGS);
    const shouldAutoOpenAndHide = config.get(AI_ASSISTANT_CONSTANTS.DYNAMIC_CONFIGS.AUTO_OPEN_AND_HIDE_ASSUMPTIONS, false);

    const toggleAccordion = () => {
        setIsOpen(prev => !prev);
    };

    useEffect(() => {
        if (shouldAutoOpenAndHide) {
            setIsOpen(true);
            const timer = setTimeout(() => setIsOpen(false), 5000);
            return () => clearTimeout(timer);
        }
    }, [shouldAutoOpenAndHide]);

    return (
        <div className={`harris-accordion ${isOpen ? "open" : ""}`}>
            <div className="accordion-header">
                <div className="left-section">
                    <FiInfo className="info-icon" />
                    <span className="accordion-title">{title}</span>
                </div>
                <button
                    type="button"
                    className="toggle-icon"
                    onClick={toggleAccordion}
                    aria-expanded={isOpen}
                    aria-label={isOpen ? "Collapse section" : "Expand section"}
                >
                    {isOpen ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}
                </button>
            </div>
            <div
                className="accordion-body-wrapper"
                style={{
                    maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : "0px",
                    transition: "max-height 0.3s ease"
                }}
            >
                <div className="accordion-body" ref={contentRef}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
